// Consistency level (api/lib/level.js): weeks you hit your own weekly target.
// A flat shield like the consistency badges, the level inside. Hidden with
// Show badges off.

import React from "react";
import { cn } from "../../lib/utils";

const SHIELD = "M32 3 L59 12 V36 C59 52 47 63 32 69 C17 63 5 52 5 36 V12 Z";

/** The big shield for your own Profile header. */
export const LevelShield = ({ level, className }) => (
  <svg viewBox="0 0 64 72" className={cn("h-[72px] w-16 shrink-0", className)} aria-hidden="true">
    <path d={SHIELD} fill="hsl(var(--muted) / 0.35)" stroke="#22B573" strokeWidth="2.5" />
    <text
      x="32"
      y="44"
      textAnchor="middle"
      fontWeight="700"
      fontSize={level >= 100 ? 20 : 26}
      fill="hsl(var(--foreground))"
      className="font-mono"
    >
      {level}
    </text>
  </svg>
);

/** A small chip beside a mate's name, from level 1. */
export const LevelChip = ({ level }) =>
  !(level > 0) ? null : (
    <span
      className="inline-flex shrink-0 items-center gap-1 rounded-full border border-border bg-muted/40 py-0.5 pl-1 pr-2 text-[11px] font-bold tabular-nums"
      title={`Level ${level}: ${level} ${level === 1 ? "week" : "weeks"} on target`}
      aria-label={`Level ${level}`}
    >
      <svg width="11" height="12" viewBox="0 0 64 72" aria-hidden="true">
        <path d={SHIELD} fill="#22B573" />
      </svg>
      {level}
    </span>
  );

/** Your level on Profile: shield, weeks on target, this week's ticks and what's next. */
export function LevelCard({ level }) {
  if (!level) return null;
  const { thisWeek } = level;
  const ticks = Array.from({ length: thisWeek.target }, (_, i) => i < thisWeek.days);
  return (
    <div className="flex items-center gap-3.5 rounded-xl border border-border bg-card p-3 lg:col-span-2">
      <LevelShield level={level.level} />
      <div className="grid min-w-0 flex-1 gap-1.5">
        <span className="text-[11px] font-semibold uppercase tracking-widest text-muted-foreground">
          Level {level.level}
        </span>
        <span className="text-sm font-semibold">
          {level.level} {level.level === 1 ? "week" : "weeks"} on target
        </span>
        <span className="flex gap-1" aria-label={`${thisWeek.days} of ${thisWeek.target} days this week`}>
          {ticks.map((on, i) => (
            <span key={i} className={cn("h-1.5 w-4 rounded-full", on ? "bg-green-500" : "bg-muted")} />
          ))}
        </span>
        <span className="text-xs text-muted-foreground">{level.next}</span>
      </div>
    </div>
  );
}
